export const VALUE_ITEMS_GAP = 4;
export const GROUP_SEPARATOR_GAP = 8;
export const DEFAULT_STICK_KEY = "ProductFlavours_DEFAULT";
